import React from "react";

import "./ExitConfirmation.css";

import WithPopup from "./../../../HOC/WithPopup/WithPopup";
import {
  Heading,
  Text,
  WhiteButton,
  RedButton,
} from "./../../../StyledComponents";
import { CancelIcon, QuestionMark } from "./../Svg";

export default (props) => {
  const containerRef = React.useRef();
  const [popupBackdropStyle, setPopupBackdropStyle] = React.useState(null);

  const cancleClickHandler = () => {
    setPopupBackdropStyle({
      animation: "fade-out-blackdrop 0.2s ease-out forwards",
    });
    containerRef.current.classList.add("exit-confirmation__container-out");
    setTimeout(props.onCancelClick, 200);
  };

  const okayClickHandler = () => {
    setPopupBackdropStyle({
      animation: "fade-out-blackdrop 0.2s ease-out forwards",
    });
    containerRef.current.classList.add("exit-confirmation__container-out");
    setTimeout(props.onOkayClick, 200);
  };

  return (
    <WithPopup backdropStyle={popupBackdropStyle}>
      <div
        className="exit-confirmation-popup__wrapper"
        automationid="Walled-Garden_Div_exit-confirmation_1"
      >
        <div
          ref={containerRef}
          className="exit-confirmation__container"
          automationid="Walled-Garden_Div_exit-confirmation_2"
        >
          <div
            onClick={cancleClickHandler}
            className="exit-confirmation-popup__-btn-close"
            automationid="Walled-Garden_Div_exit-confirmation_4"
          >
            <CancelIcon width="0.3" size="large" />
          </div>
          <QuestionMark />
          <Heading
            style={{ fontSize: "20px", color: "black" }}
            automationid="Walled-Garden_H1_exit-confirmation_1"
          >
            {props.title}
          </Heading>
          <Text
            color="black"
            textAlign="center"
            automationid="Walled-Garden_P_exit-confirmation_1"
          >
            {props.message}
          </Text>
          <div
            className="exit-confirmation__btn-container"
            automationid="Walled-Garden_Div_exit-confirmation_5"
          >
            <WhiteButton
              automationid="Walled-Garden_Button_exit-confirmation_1"
              onClick={cancleClickHandler}
            >
              {props.buttonTitles[0]}
            </WhiteButton>
            <RedButton
              automationid="Walled-Garden_Button_exit-confirmation_2"
              onClick={okayClickHandler}
              >
              {props.buttonTitles[1]}
            </RedButton>
          </div>
        </div>
      </div>
    </WithPopup>
  );
};
